// Copy a string and say so (w9-plan §6.3 item 8, §6.4). Same clipboard
// rules as Forms' PublicLinkBar: a page without a clipboard (older
// browsers, http) or a refused write gets an error toast instead of a
// silent failure.

export const COPY_ERROR = "Couldn't copy. Select it and copy it instead.";

const writeClipboard = (text) =>
  Promise.resolve().then(() => {
    const clipboard =
      typeof navigator === 'undefined' ? null : navigator.clipboard;
    if (!clipboard || typeof clipboard.writeText !== 'function') {
      throw new Error('Clipboard unavailable');
    }
    return clipboard.writeText(text);
  });

// copyText('…', 'W-9 link', onToast) → toast "W-9 link copied"
export const copyText = (text, what, onToast) =>
  writeClipboard(text).then(
    () => onToast({ type: 'success', title: `${what} copied` }),
    () => onToast({ type: 'error', title: COPY_ERROR })
  );
